import { call, put } from 'redux-saga/effects';
import {
  changeStatusAfterUpdate,
  fetchActivityLogsRequest,
  lockReturnFailure,
  lockReturnSuccess,
  submitReturnFailure,
  submitReturnSuccess,
} from '../actions';
import { ApiError, ApiResponse } from 'store/api/types';
import { LockReturnRequestAction, SubmitReturnRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import { lockReturn, submitReturn } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { DataLogStatus, SubmissionUpdateField } from 'store/app/enums';
import { updateSubmissionLog } from 'store/organisation/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { CANCEL_VAT_SAGA, LOCK_RETURN_REQUEST } from '../constants';
import { lockTifdReportFromReturnSaga } from 'store/tifd/sagas/lockTifdReportSaga';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* lockReturnSaga(action: LockReturnRequestAction) {
  const lockedTifd: boolean = yield call(lockTifdReportFromReturnSaga, action);
  if (lockedTifd) return;
  try {
    let err: ApiError | null;
    const { dataLogId, mappingId } = action.payload;
    const response: ApiResponse = yield call(lockReturn, dataLogId, mappingId);
    err = checkResponse(response?.responseMessage);
    if (err) throw err;
    const message: MessageData = {
      title: i18n.t('common.success-exclamation'),
      description: response.responseMessage.message,
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(fetchActivityLogsRequest(dataLogId));
    yield put(changeStatusAfterUpdate(DataLogStatus.LOCKED));

    yield put(lockReturnSuccess());
    yield put(
      updateSubmissionLog(
        mappingId,
        SubmissionUpdateField.STATUS,
        'LOCKED',
        dataLogId
      )
    );
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(lockReturnFailure());
  }
}
